module.exports = __webpack_public_path__ + "LGFacad_4.d4b86112.png";